import { getAttribution } from '~/utils/attribution';

/**
 * Parrainage (décision du 13/10/2026) : le parrain a 1 mois offert, le filleul 1 mois d'essai
 * (30 jours) au lieu de 14. Chaque lieu a un code court (« GRIFFIN42 », créé par stripe-b2b
 * POST /referral/code). Son lien porte utm_source=parrainage + utm_content=<CODE> ; le filleul
 * peut aussi taper le code à l'inscription. stripe-b2b (referral.js) vérifie et décide.
 * ⚠️ `REFERRAL_SOURCE`, la durée et le format du code sont à garder identiques à stripe-b2b.
 */
export const REFERRAL_SOURCE = 'parrainage';
export const REFERRAL_TRIAL_DAYS = 30;

const SITE_URL = 'https://unboared.com/';
const CODE_RE = /^[A-Z]{3,8}[0-9]{2}$/;

/** « griffin 42 » → « GRIFFIN42 ». */
export function normalizeReferralCode(value: string | undefined | null): string {
    return typeof value === 'string' ? value.toUpperCase().replace(/[\s-]/g, '') : '';
}

export function isReferralCode(value: string): boolean {
    return CODE_RE.test(value);
}

export function referralLink(code: string): string {
    const params = new URLSearchParams({
        utm_source: REFERRAL_SOURCE,
        utm_medium: 'referral',
        utm_campaign: 'parrainage',
        utm_content: code,
    });
    return `${SITE_URL}?${params.toString()}`;
}

/** Statuts d'abonnement qui montrent la carte de parrainage (un client en règle ou en essai). */
export function canRefer(status: string | undefined): boolean {
    return status === 'active' || status === 'trialing';
}

/** Code apporté par le lien de parrainage (attribution enregistrée à l'arrivée), sinon ''. */
export function referralCodeFromLink(attribution: Record<string, string> = getAttribution()): string {
    if (attribution.utm_source !== REFERRAL_SOURCE) return '';
    const code = normalizeReferralCode(attribution.utm_content);
    return isReferralCode(code) ? code : '';
}
